import React, { useEffect, useState } from 'react';
import { Modal, Col, Image, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getAllReport } from '../../redux/slices/ReportSlice';
import moment from 'moment';
import PutMeIn from './left-jab-promo.png';
import EnhanceCurrentDisputes from '../../pages/enhance_dispute/EnhanceCurrentDisputes';

const PromoModal = ({ reportStartDate }) => {
  const dispatch = useDispatch();
  // Destructure the prop here
  const reportStatus = useSelector(state => state.reports.getAllReportStatus);
  const getAllReportData = useSelector(state => state.reports.getAllReportData);
  const [show, setShow] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [remainingDays, setRemainingDays] = useState(5);
  const [disputeMailing, setDisputeMailing] = useState(false);

  const calculateEndDate = () => {
    return moment(reportStartDate).add(6, 'days');
  };

  const shouldShowModal = (reportStartDate, endDate) => {
    const currentDate = moment();
    const dayBeforeStartDate = moment(reportStartDate).add(7, 'hour');
    // //console.log('Current date: ', currentDate.format('YYYY-MM-DD'));
    // //console.log('End date: ', endDate.format('YYYY-MM-DD'));
    // //console.log('Day Before Start date: ', dayBeforeStartDate.format('YYYY-MM-DD'));
    return currentDate.isBetween(dayBeforeStartDate.format('YYYY-MM-DD H'), endDate.format('YYYY-MM-DD H'), undefined, '[]');
  };

  const getDaysRemaining = endDate => {
    const currentDate = moment();
    return endDate.diff(currentDate, 'days');
  };

  useEffect(() => {
    // dispatch(
    //   getAllReport({
    //     clientId: 1,
    //     roundid: 1,
    //   })
    // );
    return () => {
      setShowUpgradeModal(false);
    };
  }, []);

  useEffect(() => {
    const lastShown = localStorage.getItem('promoModalLastShown');
    const currentDate = moment().format('YYYY-MM-DD');
    if (!lastShown || (lastShown !== currentDate && reportStatus === 'succeeded')) {
      if (getAllReportData?.data?.round_start_date) {
        reportStartDate = moment(getAllReportData.data.round_start_date);
        const date = calculateEndDate(reportStartDate);
        if (shouldShowModal(reportStartDate, date) && getAllReportData?.data?.clientInfo.current_plan === '1') {
          setRemainingDays(getDaysRemaining(date));
          setDisputeMailing(getAllReportData?.data?.round_start_date || getAllReportData?.data?.clientInfo.mailing_option === '2');
          setShow(true);
          localStorage.setItem('promoModalLastShown', currentDate);
        }
      }
    }
  }, [getAllReportData, reportStatus]);

  const handleClose = () => setShow(false);

  return (
    <>
      <Modal show={show} onHide={handleClose} size='lg' centered>
        <Modal.Header className='justify-content-center bg-primary'>
          <div className='text-center fs-1 text-white py-1'>{remainingDays} Days Remaining!</div>
        </Modal.Header>
        <Modal.Body className='d-flex flex-row align-items-center my-3'>
          <Col xs={4}>
            <div className='h3 text-center'>Put me in coach!</div>
            <Image src={PutMeIn} width={100} className='mx-auto d-flex' />
          </Col>
          <Col xs={6} className='mx-auto'>
            {disputeMailing ? (
              <>
                <div className='h3'>Upgrade to Enhanced and get more!</div>
                <p>Sure, Disputely is already mailing your letters for you... </p>
                <p>But there is so much more we can do ...</p>
                <p>Take full advantage of all the tools that Disputely offers and go Enhanced, NOW! </p>
              </>
            ) : (
              <>
                <div className='h3'>It's not too late!</div>
                <p>Most companies charge hundreds of dollars to do almost the exact same thing that you are getting for free. </p>
                <p> Why go through all the trouble of printing them and getting envelopes and stamps and having to spell Equifax -- you get the point.</p>
                <p>Save time and let us handle it for you </p>
              </>
            )}
          </Col>
        </Modal.Body>
        <Modal.Footer className='d-flex justify-content-between'>
          <Button variant='outline-secondary' onClick={handleClose}>
            Ill stick to my Current Plan
          </Button>
          <Button
            variant='primary'
            onClick={() => {
              handleClose();
              setShowUpgradeModal(true);
            }}>
            You're right, do it for me!
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal centered size={disputeMailing ? 'md' : 'lg'} show={showUpgradeModal} onHide={() => setShowUpgradeModal(false)}>
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          <EnhanceCurrentDisputes disputelyMailed={disputeMailing} onPlanClick={() => setShowUpgradeModal(false)} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PromoModal;
